import { FlowState } from "../models/model";
import { FlowActions } from "../interface/reducerType";

const initialState = {
  edges: "",
  nodes: "",
  selectedElement: {},
  updatedType: "",
  updatedData: {},
  isUpdate: false,
  dtmfInput: [],
  apiResponseKey: [],
};
export const flowReducer = (
  state: FlowState = initialState,
  action: FlowActions
) => {
  switch (action.type) {
    case "FLOW":
      return {
        ...state,
        edges: action.payload.edges,
        nodes: action.payload.nodes,
      };
    case "SELECTED_NODE":
      return {
        ...state,
        selectedElement: action.payload.selectedElement,
      };
    case "FLOW_UPDATE":
      return {
        ...state,
        updatedType: action.payload.updatedType,
        updatedData: action.payload.updatedData,
        isUpdate: action.payload.isUpdate,
      };
    case "ADD_DTMFINPUT":
      return {
        ...state,
        dtmfInput: action.payload.dtmfInput,
      };
    case "ADD_RESPONSE_URL":
      return {
        ...state,
        apiResponseKey: action.payload.apiResponseKey,
      };

    default:
      return state;
  }
};
